import FeedbackContainer from './Container';
import Video from './FeedbackPreview/FeedbackPreviewVideo';
import Sound from './FeedbackPreview/FeedbackPreviewSound';

export const FeedbackPreview = { Sound, Video };

export default FeedbackContainer;
